// メッセージファイル

export const message = 
{
    REQUIRED : "入力してください",
    SELECTIONREQUIERED : "選択してください",
    EITHERONEREQUIRED : "どちらか一つを入力してください",
    MAX : "文字以内で入力してください",
}
